import React from "react";

export const BigExclamation = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_7340_2653)">
      <rect x="4" y="4" width="40" height="40" rx="20" fill="#F9E8EA" />
      <rect
        x="4.5"
        y="4.5"
        width="39"
        height="39"
        rx="19.5"
        stroke="url(#paint0_linear_7340_2653)"
      />
      <g clipPath="url(#clip0_7340_2653)">
        <path
          d="M24 14C22.0222 14 20.0888 14.5865 18.4443 15.6853C16.7998 16.7841 15.5181 18.3459 14.7612 20.1732C14.0043 22.0004 13.8063 24.0111 14.1922 25.9509C14.578 27.8907 15.5304 29.6725 16.9289 31.0711C18.3275 32.4696 20.1093 33.422 22.0491 33.8079C23.9889 34.1937 25.9996 33.9957 27.8268 33.2388C29.6541 32.4819 31.2159 31.2002 32.3147 29.5557C33.4135 27.9112 34 25.9778 34 24C33.9971 21.3487 32.9426 18.8068 31.0679 16.9321C29.1932 15.0574 26.6513 14.0029 24 14ZM24 32.3333C22.3518 32.3333 20.7407 31.8446 19.3703 30.9289C17.9998 30.0132 16.9317 28.7117 16.301 27.189C15.6703 25.6663 15.5053 23.9908 15.8268 22.3742C16.1483 20.7577 16.942 19.2729 18.1074 18.1074C19.2729 16.942 20.7577 16.1483 22.3743 15.8268C23.9908 15.5052 25.6663 15.6703 27.189 16.301C28.7118 16.9317 30.0132 17.9998 30.9289 19.3702C31.8446 20.7407 32.3333 22.3518 32.3333 24C32.3309 26.2094 31.4522 28.3276 29.8899 29.8899C28.3276 31.4522 26.2094 32.3309 24 32.3333Z"
          fill="#BF1A2F"
        />
        <path
          d="M24.0003 18.1667C23.7793 18.1667 23.5674 18.2545 23.4111 18.4108C23.2548 18.5671 23.167 18.7791 23.167 19.0001V25.6667C23.167 25.8878 23.2548 26.0997 23.4111 26.256C23.5674 26.4123 23.7793 26.5001 24.0003 26.5001C24.2213 26.5001 24.4333 26.4123 24.5896 26.256C24.7459 26.0997 24.8337 25.8878 24.8337 25.6667V19.0001C24.8337 18.7791 24.7459 18.5671 24.5896 18.4108C24.4333 18.2545 24.2213 18.1667 24.0003 18.1667Z"
          fill="#BF1A2F"
        />
        <path
          d="M24.8337 29.0001C24.8337 28.5398 24.4606 28.1667 24.0003 28.1667C23.5401 28.1667 23.167 28.5398 23.167 29.0001C23.167 29.4603 23.5401 29.8334 24.0003 29.8334C24.4606 29.8334 24.8337 29.4603 24.8337 29.0001Z"
          fill="#BF1A2F"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_7340_2653"
        x="0"
        y="0"
        width="48"
        height="48"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_7340_2653"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.305882 0 0 0 0 0.305882 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7340_2653"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7340_2653"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_7340_2653"
        x1="24"
        y1="4"
        x2="24"
        y2="44"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA7A7" />
        <stop offset="1" stopColor="#FFA7A7" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_7340_2653">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(14 14)"
        />
      </clipPath>
    </defs>
  </svg>
);
